(ns lemonpi.content-function.interface.macro
  "Parse/serialize macros. Internal representation of macros
   changed with time. In the first place it was a keyword of :alias.selector (m0), but
   later on we extended the syntax (m1), so the internal representation was changed to
   a map. Because we save internal representation to the database, this module
   must be able to read the 'keyword' representation as well."
  (:require [lemonpi.content-function.shared.macro :as m]))

(defn parse-int
  [s]
  (m/parse-int s))

;; Internal representation must be repsesentable in JSON
;; because it is saved like that into the database.
(defn create-macro
  ([alias selector] (create-macro alias selector []))
  ([alias selector function]
   (m/create-macro alias selector function)))

(defn parse-fn-args
  [args-string]
  (m/parse-fn-args args-string))

(defn parse-fn-int-args
  [f]
  (m/parse-fn-int-args f))

(defn parse-fn-string-args
  [f]
  (m/parse-fn-string-args f))

(defn parse-fn
  [f]
  (m/parse-fn f))

(defn parse-macro
  "Parses a macro. Returns nil if it is not valid."
  [m]
  (m/parse-macro m))

(defn macro?
  "Checks if a given term is a macro representation"
  [m]
  (m/macro? m))

(defn macro-literal?
  "Checks if a given string is a macro. It does not validate the inner part,
   only checks for the aiter syntax."
  [m]
  (m/macro-literal? m))

(defn serialize-macro
  [m]
  (m/serialize-macro m))

(defn get-full-path
  [m]
  (m/get-full-path m))

(defn upgrade-macro
  [m]
  (m/upgrade-macro m))

(defn macro-expr?
  [x]
  (m/macro-expr? x))

(defn parse-macro-expr
  "Parses a string that may contain macros. For example:

    \"Hello ${MACRO}!!\"

  will be converted to:

    [\"Hello \" MACROREP \"!!\"]"
  [expr]
  (m/parse-macro-expr expr))

(defn serialize-macro-expr
  "Serializes a series of terms that may cntain macros to string.
  For example:

    [\"Hello \" MACROREP \"!!\"]

  will be serialized to:

    \"Hello ${MACRO}!!\""
  [expr]
  (m/serialize-macro-expr expr))
